// extracted by mini-css-extract-plugin
export var video = "video-module--video--5VM6K";